export default {
  title: "Courses",
  completed: "Completed",
  startOver: "Start over",
  detail: "Detail",
  begin: "Detail",
  continue: "Continue",
  buyAndPlay: "Buy and Play",
  backToJourney: "Back to Course",
};
